import React, { memo } from 'react';
import Popup from '../helpers/Popup';
import FormGroup from '../helpers/FormGroup';
import Input from '../helpers/Input';
import Button from '../helpers/Button';
import ErrorList from '../helpers/ErrorList';

const NewIndustryPopup = props => {
  const { onCreate, onClose, onChange, industryLabel, errors, status } = props;
  const header = 'Add a new industry to the master list';
  const footer = (
    <>
      <Button
        key="create"
        className="btn-primary"
        data-dismiss="modal"
        disabled={industryLabel.length === 0}
        loading={status === 'saving'}
        onClick={onCreate}
      >
        Create
      </Button>
      <Button key="close" data-dismiss="modal" onClick={onClose}>
        Cancel
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="newIndustryPopup">
      <div className="row">
        <FormGroup className="col-lg-6 col-xs-12">
          <Input
            className="input-sm"
            id="k-industry-name"
            label="Industry Label"
            name="industryLabel"
            onChange={onChange}
            placeholder="Industry Label"
            value={industryLabel}
            autoFocus
            required
            showLabel
          />
        </FormGroup>
        {errors.size > 0 && (
          <div className="col-lg-6 col-xs-12">
            <ErrorList className="text-danger" errors={errors} />
          </div>
        )}
      </div>
    </Popup>
  );
};

export default memo(NewIndustryPopup);
